import React, { useState, useRef, useEffect } from "react";
import "../../styles.css";

function Tutorial({ steps, setIsTutorialVisible }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const targetRef = useRef(null);
  const bubbleRef = useRef(null);
  const currentStepData = steps[currentStep];

  useEffect(() => {
    if (currentStepData && currentStepData.targetSelector) {
      targetRef.current = document.querySelector(
        currentStepData.targetSelector
      );
      positionBubble();
    }
  }, [currentStep, currentStepData]);

  const positionBubble = () => {
    if (!targetRef.current || !bubbleRef.current) return;

    const targetRect = targetRef.current.getBoundingClientRect();
    const bubbleRect = bubbleRef.current.getBoundingClientRect();

    // Calculate position
    const top = targetRect.top - bubbleRect.height - 10; // Adjust as needed
    const left = targetRect.left + targetRect.width / 2 - bubbleRect.width / 2; // Center

    bubbleRef.current.style.top = `${top}px`;
    bubbleRef.current.style.left = `${left}px`;
  };

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      setIsTutorialVisible(false);
    }
  };

  if (!isVisible || !currentStepData) return null;

  return (
    <div className="tutorial-overlay">
      <div className="tutorial-bubble" ref={bubbleRef}>
        <p>{currentStepData.content}</p>
        <button className="tutorial-next-button" onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  );
}

export default Tutorial;
